import { defineFormSchema } from '../../../shared/data/formSchema';
export const formSchema = defineFormSchema({
  "id": "staff.member.create",
  "fields": [
    { "name": "firstName", "label": "Nome", "type": "text", "required": true },
    { "name": "lastName", "label": "Cognome", "type": "text", "required": true },
    {
      "name": "name",
      "label": "Nome e Cognome", "required": true,
      "type": "text"
    },
    {
      "name": "role",
      "label": "Ruolo", "required": true,
      "type": "text"
    },
    {
      "name": "email",
      "label": "Email",
      "type": "email"
    },
    {
      "name": "phone",
      "label": "Telefono",
      "type": "tel"
    },
    {
      "name": "skills",
      "label": "Competenze",
      "type": "text"
    }
  ]
});
